import React from "react";
import ResearchIcon from "../../../assets/icons/fancy/ResearchIcon";
import "./HomeQuest.css";

const HomeQuest = () => {
  return (
    <section className="home-quest">
      <div className="quest-text">
        <h2 className="quest-title">Quest Diagnostics Lab</h2>
        <p className="quest-description">
          Laboratory analysis is an important component in disease diagnosis and
          medication monitoring. Quest Diagnostics Lab is conveniently located
          in our office to perform blood draws for our patients.
          <br />
          <br />
          Mon, Tues, Thurs, Fri 8-3:30 pm.
          <br />
          Closed 12:30-1pm for lunch.
          <br />
          <br />
          <a href="https://insurance.questdiagnostics.com">
            <b>Click here to check your network status with Quest Labs</b>
          </a>
        </p>
      </div>
      <div className="quest-img-wrapper">
        <ResearchIcon />
      </div>
    </section>
  );
};

export default HomeQuest;
